// this doesn't really need to be a function, but making it a function to be
// consistent with sibling methods, and to allow for conditional fallbacks if we
// ever need that

module.exports = function getFallbackImage() {
    return {
        url: require('images/placeholders/silhouette-gray.svg'),
        width: 921,
        height: 614,
        highlight: {
            x: 0,
            y: 0,
            w: 921,
            h: 614,
        },
    }
}
